import { render, staticRenderFns } from "./viewCardAddNote.vue?vue&type=template&id=e09528dc"
import script from "./viewCardAddNote.vue?vue&type=script&lang=js"
export * from "./viewCardAddNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports